import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const RelatedBreakToolTip = (props) => (
  <div>
    Headline of a live break. This will be placed on the bottom of the current break and provides readers with a link to similar content. When a link is added, the title will appear under a heading that says “RELATED CONTENT”
    <br/>
    <img src={makeToolTipUrl('break/general/16.CMS-related-break.png')} width="100%"/>
  </div>
);

export const RelatedBreakUrlToolTip = (props) => (
  <div>
    The "Break URL Name" of the break you are featuring. This does <b>NOT</b> need the full web address ex: "https://www.dailybreak.com/break/"
  </div>
);

export const FBCommentQuestionToolTip = (props) => (
  <div>
    A prompting question that encourages readers to comment on the Facebook board.
  </div>
);

export const ShowNextButtonToolTip = (props) => (
  <div>
    If yes, this allows reader to move onto the next step
    <img src={makeToolTipUrl(`${props.stepType}/showNextBtn.png`)} width="100%"/>
  </div>
);

export const NextButtonTextToolTip = (props) => (
  <div>
    Default is “Next”, can be changed if you need a more direct call to action.
  </div>
);

export const NextButtonLinkTypeToolTip = (props) => (
  <div>
    “Button” is for the main call to action. “Text” is available if the button is a secondary call to action.
  </div>
);


export const ShowSkipLinkToolTip = (props) => (
  <div>
    If yes, “Skip” will appear to allow the readers to move to the next step without completing.
    <img src={makeToolTipUrl(`${props.stepType}/showSkipButton.png`)} width="100%"/>
  </div>
);

export const SkipLinkTextToolTip = (props) => (
  <div>
    Default is “Skip”, can be changed if you need a more direct call to action.
  </div>
);

export const SkipLinkLinkTypeToolTip = (props) => (
  <div>
    “Button” is for the main call to action. “Text” is available if the button is a secondary call to action.
  </div>
);

export const SharingOnToolTip = (props) => (
  <div>
    If yes, all sharing fields (Facebook, Twitter, Pinterest, Email, Print) will be turned on for this step.
    <img src={makeToolTipUrl(`${props.stepType}/socialShareOn.png`)} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-steps-section-tool-tips.jsx